import axios from 'axios';
import { URL2 } from '../constants/config';


const instance = axios.create({ 
  baseURL: URL2,
  headers: {
    'Content-type': 'application/json'
  },});
instance.interceptors.request.use(function (config) {
  config.headers.Authorization = localStorage.getItem('token');
  return config;
});

export default instance